<template>
    <div @click="goBack" class="goBack">
        &lt;
    </div>
</template>

<script>
import { MOBILE_API } from '@/constants/api' 

export default {
    name: "goBack",
    methods: {
        goBack(){
            window.location.href = MOBILE_API.EXIT;
        }
    }
}
</script>

<style lang="scss" scoped>
.goBack{
    cursor: pointer;
    font-size: .4rem;
    font-weight: 600;
    width: .6rem;
    height: .6rem;
    background: rgba(0, 0, 0, .2);
    border-radius: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>